import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { DynamicActionProviderComponent } from './components/context-binding/dynamic-action-provider/dynamic-action-provider.component';
import {
  DynamicActionTypeDirective,
  DynamicBindingProviderComponent,
  DynamicFormTypeDirective,
  DynamicValueTypeDirective,
} from './components/context-binding/dynamic-binding-provider/dynamic-binding-provider.component';
import { DynamicFormControlProviderComponent } from './components/context-binding/dynamic-form-control-provider/dynamic-form-control-provider.component';
import { DynamicValueProviderComponent } from './components/context-binding/dynamic-value-provider/dynamic-value-provider.component';
import { DynamicComponentRendererComponent } from './components/dynamic-component-renderer/dynamic-component-renderer.component';
import { DynamicRenderTrackerDirective } from './components/dynamic-render-tracker.directive';
import { DynamicRendererComponent } from './components/dynamic-renderer/dynamic-renderer.component';
import { scheduledAsync } from './functions/scheduled-async';
import { DynamicContextResolverPipe } from './pipes/dynamic-context-resolver.pipe';
import { FormControlResolverPipe } from './pipes/form-control-resolver.pipe';
import { JsonataPipe } from './pipes/jsonata.pipe';
import { DynamicComponentRegistryService } from './services/dynamic-component-registry.service';
import { DynamicFormBuilderService } from './services/dynamic-form-builder.service';
import { IDynamicComponentsModuleConfig } from './types/dynamic-components-module-config.interface';
import { DYNAMIC_COMPONENT_MODULES } from './types/modules.symbol';
import { OBSERVABLE_CREATOR, ObservableCreator } from './types/observable-creator.symbol';

@NgModule({
  declarations: [
    DynamicActionTypeDirective,
    DynamicActionProviderComponent,
    DynamicBindingProviderComponent,
    DynamicComponentRendererComponent,
    DynamicContextResolverPipe,
    DynamicFormTypeDirective,
    DynamicFormControlProviderComponent,
    DynamicRendererComponent,
    DynamicRenderTrackerDirective,
    DynamicValueTypeDirective,
    DynamicValueProviderComponent,
    FormControlResolverPipe,
    JsonataPipe,
  ],
  exports: [
    DynamicActionTypeDirective,
    DynamicActionProviderComponent,
    DynamicBindingProviderComponent,
    DynamicComponentRendererComponent,
    DynamicContextResolverPipe,
    DynamicFormTypeDirective,
    DynamicFormControlProviderComponent,
    DynamicRendererComponent,
    DynamicValueTypeDirective,
    DynamicValueProviderComponent,
    FormControlResolverPipe,
    JsonataPipe,
  ],
  imports: [CommonModule],
  providers: [DynamicComponentRegistryService, DynamicFormBuilderService],
})
export class DynamicComponentsModule {
  static forFeature(
    config: IDynamicComponentsModuleConfig,
    observableCreator?: ObservableCreator
  ): ModuleWithProviders<DynamicComponentsModule> {
    return {
      ngModule: DynamicComponentsModule,
      providers: [
        { provide: DYNAMIC_COMPONENT_MODULES, useValue: config?.modules ?? [] },
        { provide: OBSERVABLE_CREATOR, useValue: observableCreator ?? scheduledAsync },
      ],
    };
  }
}
